import { FULL_PAGE_EDITOR_TOOLBAR_HEIGHT } from '@atlaskit/editor-shared-styles/constants';

export const getAdjustedTopPropertyValue = (userOffline: boolean): string => {
	const offlineBannerHeight = 32;
	let toolbarHeight: string = FULL_PAGE_EDITOR_TOOLBAR_HEIGHT();
	if (userOffline) {
		toolbarHeight = `calc(${toolbarHeight} + ${offlineBannerHeight}px)`;
	}
	return toolbarHeight;
};
